import { Alert, Box, IconButton, Menu, MenuItem, TextField, Tooltip, Typography, InputAdornment,  } from "@mui/material";
import { useContext, useState } from "react";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import { CartsContext } from "./_CartsContext";
import Iconify from "../../../../../reusable-components/iconify/Iconify";
import { ConfirmDialog } from "../../../../../reusable-components/confirm-dialog";

DeleteItemButton.propTypes = {
  params: PropTypes.any
}

function DeleteItemButton({ params }) {
  const [deleting, setDeleting] = useState(false);
  const { carts, deleteItem } = useContext(CartsContext);
  const lastItem = !carts?.some(cart => cart.items?.some(item => params.row.punchoutLocked ? item.punchoutId !== params.row.punchoutId : item.id !== params.row.id));

  return <ConfirmDialog
    icon="delete-outline"
    title="Delete item?"
    color="error"
    content={<Box>
      {params.row.punchoutLocked ? `The vendor doesn't allow changes to punchout orders. If you delete this item the whole punchout will be removed.`
        : `Are you sure want to delete ${params.row.description}?`}
      {lastItem && <Alert severity="error" sx={{ mt: 1 }}>This will remove your cart.</Alert>}
    </Box>}
    actionButton="Delete"
    manualLoading={deleting}
    iconButtonSx={{ padding: '0px', margin: '0px', marginLeft: '5px' }} 
    action={() => deleteItem(params.row.id, params.row.itemId, params.row.punchoutItemId, params.row.punchoutId, params.row.punchoutLocked, lastItem, setDeleting)}
  />
};

QuantityField.propTypes = {
  params: PropTypes.any,
  canViewCart: PropTypes.bool,
  showTableCheckbox: PropTypes.bool
}

export function QuantityField({ params, canViewCart, showTableCheckbox })  {
  const { updateCartItemFields } = useContext(CartsContext);

  const updateQuantity = (newQuantity) => {
    const newValue = Number(newQuantity);
    if (Number.isNaN(newValue) || newValue < 0 || newValue > 999999999) return;
    if (params.row.origQty === undefined) params.row.origQty = params.row.quantity;
    params.row.quantity = newValue
    params.api.updateRows([params.row]);
    updateCartItemFields(params.row.id, [{ field: 'quantity', value: newValue }]);
  }

  

  return canViewCart ? <>
    <Tooltip title={params.row.punchoutLocked ? "The vendor doesn't allow changes to punchout orders, to make changes, you must place a new order." : ""} placement="top" arrow>
      <TextField
        size="small"
        value={params.row.quantity || 0}
        disabled={params.row.punchoutLocked}
        onChange={(e) => updateQuantity(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
        autoComplete="off"
        inputProps={{ style: { textAlign: 'center' } }}
        InputProps={{
          style: { height: '32px', borderRadius: '10px', padding: '4px' },
          startAdornment: (
            <InputAdornment position="start" sx={{ m: 0 }}>
              <IconButton
                size="small"
                sx={{ p: '1px', height: 22, minWidth: 22 }}
                disabled={params.row.quantity <= 0}
                onClick={() => {
                  if (params.row.quantity > 0) {
                    const newValue = params.row.quantity - 1;
                    updateQuantity(newValue);
                  }
                }}
                edge="start"
              >
                <RemoveIcon fontSize="inherit" sx={{ fontSize: 14 }} />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" sx={{ m: 0 }}>
              <IconButton
                size="small"
                sx={{ p: '1px', height: 22, minWidth: 22 }}
                onClick={() => {
                  const newValue = (params.row.quantity || 0) + 1;
                  updateQuantity(newValue);
                }}
                edge="end"
              >
                <AddIcon fontSize="inherit" sx={{ fontSize: 14 }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Tooltip> 
    {!showTableCheckbox && <DeleteItemButton params={params} />}
  </> : <TextField size="small" disabled value={params.row.quantity || ''} autoComplete="off"/>;
};

UOMField.propTypes = {
  params: PropTypes.any
}

export function UOMField({ params }) {
  const { updateCartItemFields } = useContext(CartsContext);
  const [anchorEl, setAnchorEl] = useState(null);

  const updateUOMType = (uom) => {
    params.api.updateRows([{ ...params.row, origUOMType: params.row.origUOMType ?? params.row.uomType, uomAmount: uom.uomAmount, uomType: uom.uomType, price: uom.price }]);
    updateCartItemFields(params.row.id, [{ field: 'uomAmount', value: uom.uomAmount }, { field: 'uomType', value: uom.uomType }, { field: 'price', value: uom.price }]);
    setAnchorEl(null);
  }

  return params.row.productUOMs?.length > 0 ? <>
    <Typography
      variant="subtitle2"
      sx={{
        border: 1,
        width: '125px',
        borderRadius: '3px',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: `#C4CDD5`,
        },
        my: '4px',
        py: '4px',
        px: 0.5,
      }}
      onClick={(event) => setAnchorEl(event.currentTarget)}
    >
      <Box sx={{ flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', px: 0.5 }}>
        {params.row.uomAmount}/{params.row.uomType}
      </Box>
      <Iconify icon={'mdi:chevron-down'} />
    </Typography >
    <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
      {params.row.productUOMs.map((uom, index) => (
        <MenuItem key={index} onClick={() => updateUOMType(uom)}>
          <Typography variant="body2">
            {uom.uomAmount}/{uom.uomType}
          </Typography>
        </MenuItem>
      ))}
    </Menu>
  </> : `${params.row.uomAmount}/${params.row.uomType}`;
};